import React from "react";
import {faUnlockAlt, faUser} from "@fortawesome/free-solid-svg-icons";
import {Button, Col, Container, Form, Image, Row} from '@themesberg/react-bootstrap';
import icLogoAbacus from "../../assets/img/ic_logo_abacus.png";
import BasePage from "../base/BasePage";
import label from 'enqc-utilities/src/label/Label'
import {cleanSpace, isResponseOk} from "enqc-utilities/src/utils/Utilities";
import Global from "../../utils/Global";
import {toasting} from "../base/BaseComponent";
import TextInput from "../../components/input/TextInput";
import PasswordInput from "../../components/input/PasswordInput";
import {storeData, getData} from "../../utils/StorageUtil";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import ResetPasswordPage from "./ResetPasswordPage";
import {GoogleReCaptchaProvider, useGoogleReCaptcha} from "react-google-recaptcha-v3";

class SigninPage extends BasePage{

  constructor(props) {
    super(props);
    this.state = {
      username : "",
      password:"",
      rememberMe : false,
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.fetchRecaptchaSiteKey()
    this.props.closePreLoader()
  }

  fetchRecaptchaSiteKey = () => {
    this.get(Endpoint.API.GOOGLE_RECAPTCHA_SITE_KEY, {
      params:{}
    }, null, response=>{
      if(response.code === 200){
        let recaptchaSiteKey = response.data
        storeData(Global.GOOGLE_RECAPTCHA_SITE_KEY, recaptchaSiteKey)
        console.log("@@@@@@@@@@@@@@@@@@ "+recaptchaSiteKey)
        this.setState({
          recaptchaSiteKey
        }, () => {
          this.forceUpdate()
        })
      }
    }, true, true);
  }

  async login(executeRecaptcha){
    let {username, password, rememberMe} = this.state
    this.showPostProgress()
    const token = await executeRecaptcha("login_action");
    this.closePostProgress()
    let params = {}
    params.usernameOrEmail = username
    params.password = password
    params.rememberMe =  rememberMe
    this.post(Endpoint.API.AUTH, null, {params:params, headers:{grt:token}},  async (response)=>{
      if(response && isResponseOk(response)){
        let user = response.data
        if(user.shouldChangePassword){
          let form = new FormData()
          form.append("userId", user.id)
          let res = await this.asyncPost(Endpoint.API.USER_FETCH_RESET_PASSWORD, form, null, true, true);
          if(isResponseOk(res)){
            let resetPassword = res.data
            window.location.href = ResetPasswordPage.ENDPOINT+"/"+resetPassword.token
            return
          }
        }
        storeData(Global.AUTHORIZATION, response.data.authorization)
        storeData(Global.USER, user)
        window.location.href = "/"
        // window.location.reload()
      }else {
        if(response){
          toasting.error(response.message)
        }else{
          toasting.error(label.SomethingUnexpected)
        }
      }
    }, true,false)
  }

  render(){
    let {username, password, rememberMe, recaptchaSiteKey} = this.state
    let disableSubmit = !(username.length>4 && password.length>2)

    if(!recaptchaSiteKey){
      recaptchaSiteKey = getData(Global.GOOGLE_RECAPTCHA_SITE_KEY)
    }
    if (!recaptchaSiteKey) {
      return <div>Loading...</div>;
    }

    return (
        <>
          {super.render()}
          <GoogleReCaptchaProvider
              reCaptchaKey={recaptchaSiteKey}
              scriptProps={{
                async: true,
                defer: true,
                appendTo: "head"
              }}>
            <AuthFormWithCaptcha
                username={username}
                password={password}
                rememberMe={rememberMe}
                recaptchaSiteKey={recaptchaSiteKey}
                setState={(data) => this.setState(data)}
                login={(executeRecaptcha) => {this.login(executeRecaptcha)}}
            />
          </GoogleReCaptchaProvider>
          {/*<main>*/}
          {/*  <section className="d-flex align-items-center my-5 mt-lg-5 mb-lg-5">*/}
          {/*    <Container>*/}
          {/*      <Row className="justify-content-center form-bg-image">*/}
          {/*        <Col xs={12} className="d-flex align-items-center justify-content-center">*/}
          {/*          <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-4 w-100 fmxw-500">*/}
          {/*            <div className="text-center text-md-center mb-4 mt-md-0">*/}
          {/*              <Image className="w-80 mt-4 mb-5" src={icLogoAbacus}/>*/}
          {/*              <h3 className="mb-0">{label.SignInToAssembler}</h3>*/}
          {/*            </div>*/}
          {/*            <Form className="mt-2">*/}
          {/*              <TextInput*/}
          {/*                  label={label.UsernameOrEmail}*/}
          {/*                  icon={faUser}*/}
          {/*                  required={false}*/}
          {/*                  placeholder={label.EnterUsernameMail}*/}
          {/*                  value={username}*/}
          {/*                  onChange={(value) => {*/}
          {/*                    value = cleanSpace(value)*/}
          {/*                    this.setState({username:value})*/}
          {/*                  }}*/}
          {/*              />*/}
          {/*              <Form.Group>*/}
          {/*                <PasswordInput*/}
          {/*                    label={label.Password}*/}
          {/*                    icon={faUnlockAlt}*/}
          {/*                    placeholder={label.EnterConfirmPassword}*/}
          {/*                    value={password}*/}
          {/*                    masking={true}*/}
          {/*                    onChange={(value) => {*/}
          {/*                      password = cleanSpace(value)*/}
          {/*                      this.setState({password})*/}
          {/*                    }}*/}
          {/*                    onEnter={async (value) => {*/}
          {/*                      await this.login()*/}
          {/*                    }}*/}
          {/*                />*/}
          {/*              </Form.Group>*/}
          {/*              <Button*/}
          {/*                  variant="primary"*/}
          {/*                  className="w-100"*/}
          {/*                  onClick={async (event) => {*/}
          {/*                    await this.login()*/}
          {/*                  }}*/}
          {/*                  disabled={disableSubmit}>*/}
          {/*                {label.SignIn}*/}
          {/*              </Button>*/}
          {/*            </Form>*/}
          {/*            <div className="d-flex justify-content-center align-items-center mt-4">*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </Col>*/}
          {/*      </Row>*/}
          {/*    </Container>*/}
          {/*  </section>*/}
          {/*</main>*/}
        </>
    );
  }
}

const AuthFormWithCaptcha = (props) => {
  const {
    username,
    password,
    rememberMe,
    recaptchaSiteKey,
    setState,
    login
  } = props;
  let disableSubmit = !(username.length>4 && password.length>2)
  const { executeRecaptcha } = useGoogleReCaptcha();
  return (
        <main>
          <section className="d-flex align-items-center my-5 mt-lg-5 mb-lg-5">
            <Container>
              <Row className="justify-content-center form-bg-image">
                <Col xs={12} className="d-flex align-items-center justify-content-center">
                  <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-4 w-100 fmxw-500">
                    <div className="text-center text-md-center mb-4 mt-md-0">
                      <Image className="w-80 mt-4 mb-5" src={icLogoAbacus}/>
                      <h3 className="mb-0">{label.SignInToAssembler}</h3>
                    </div>
                    <Form className="mt-2">
                      <TextInput
                          label={label.UsernameOrEmail}
                          icon={faUser}
                          required={false}
                          placeholder={label.EnterUsernameMail}
                          value={username}
                          onChange={(value) => {
                            value = cleanSpace(value)
                            setState({username:value})
                          }}
                      />
                      <Form.Group>
                        <PasswordInput
                            label={label.Password}
                            icon={faUnlockAlt}
                            placeholder={label.EnterConfirmPassword}
                            value={password}
                            masking={true}
                            onChange={(value) => {
                              value = cleanSpace(value)
                              setState({password:value})
                            }}
                            onEnter={async (value) => {
                              await login(executeRecaptcha)
                            }}
                        />
                      </Form.Group>
                      <Button
                          variant="primary"
                          className="w-100"
                          onClick={async (event) => {
                            await login(executeRecaptcha)
                          }}
                          disabled={disableSubmit}>
                        {label.SignIn}
                      </Button>
                    </Form>
                    <div className="d-flex justify-content-center align-items-center mt-4">
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
  );
};


export const SIGNIN_ENDPOINT = "/auth/sign-in"
export default Object.assign(SigninPage, {ENDPOINT : SIGNIN_ENDPOINT})
